/**
 * 盤の外・直上に 1 行だけ出す目的文 (「何をすれば勝ちか」)。
 *
 * Play (対局中) と Puzzle で共通。 盤の中に重ねると駒と競合するので、 常に盤の
 * 外側に flow で置く。 高さを消費するので、 盤側の縦 budget (`--board-budget-h`)
 * はこの 1 行ぶんを引いた値になっている。
 */

import { gameObjective } from '../lib/game-meta';
import type { GameId } from '../wasm';

export function BoardObjective({ game, concise = false }: { game: GameId; concise?: boolean }): JSX.Element | null {
  const obj = gameObjective(game);
  if (!obj) return null;
  return (
    <p className="board-objective" data-testid="board-objective">
      <span className="board-objective-goal">{obj.goal}</span>
      {!concise && obj.note && <span className="board-objective-note">{obj.note}</span>}
    </p>
  );
}
